import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-343e9192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ShareUser__container" }
const _hoisted_2 = { class: "ShareUser__avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "ShareUser__info"
}
const _hoisted_5 = {
  class: "ShareUser__nickname",
  "data-test": "nickname"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ShareUser__message",
  "data-test": "invite-message"
}, "邀请你加入队伍，一起赚KK币免费看漫画", -1))

import { useStore } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    nickName: null,
    avatar: null
  },
  setup(__props: any) {

const store = useStore();
const host = computed(() => store.state.host);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.avatar)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "ShareUser__img",
            src: _unref(host) + __props.avatar
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    (__props.nickName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.nickName), 1),
          _hoisted_6
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})